
    import './styles.scoped.css';
    export default {
  "tutorial-list": "awsui_tutorial-list_1u70p_80nvq_99",
  "tutorial-title": "awsui_tutorial-title_1u70p_80nvq_138",
  "task": "awsui_task_1u70p_80nvq_145",
  "task-title": "awsui_task-title_1u70p_80nvq_153",
  "task-title--status": "awsui_task-title--status_1u70p_80nvq_161",
  "current-task": "awsui_current-task_1u70p_80nvq_165",
  "successful-task": "awsui_successful-task_1u70p_80nvq_169",
  "congratulation-message": "awsui_congratulation-message_1u70p_80nvq_173",
  "congratulation-message--status": "awsui_congratulation-message--status_1u70p_80nvq_181",
  "plaintext-congratulation-description": "awsui_plaintext-congratulation-description_1u70p_80nvq_185",
  "divider": "awsui_divider_1u70p_80nvq_189",
  "step-list": "awsui_step-list_1u70p_80nvq_193",
  "step": "awsui_step_1u70p_80nvq_193",
  "expandable-section-wrapper": "awsui_expandable-section-wrapper_1u70p_80nvq_204",
  "expandable-section-header": "awsui_expandable-section-header_1u70p_80nvq_208",
  "step-title": "awsui_step-title_1u70p_80nvq_213",
  "feedback-link": "awsui_feedback-link_1u70p_80nvq_214",
  "dismiss-button": "awsui_dismiss-button_1u70p_80nvq_215",
  "completion-screen-title": "awsui_completion-screen-title_1u70p_80nvq_216",
  "completion-screen-description": "awsui_completion-screen-description_1u70p_80nvq_217"
};
  